Groupon.verifyUserCookies = function() {
  return setTimeout((function() {
    var el, ref, src;
    if (!(src = Groupon.endpoints.verifyCookies)) {
      return;
    }
    if ((ref = window.sessionStorage) != null ? ref.getItem('verifiedCookies') : void 0) {
      return;
    }
    el = document.createElement('script');
    el.id = 'verify_cookies';
    el.async = true;
    document.body.appendChild(el).src = src;
    try {
      return typeof sessionStorage !== "undefined" && sessionStorage !== null ? sessionStorage.setItem('verifiedCookies', true) : void 0;
    } catch (error) {}
  }), 0);
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2pwdmVyZGVqby9Hcm91cG9uL3Nscy9jb3JlL2Zyb250ZW5kL2dyb3Vwb25fbW9kdWxlcy92ZXJpZnlVc2VyQ29va2llcy5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvVXNlcnMvanB2ZXJkZWpvL0dyb3Vwb24vc2xzL2NvcmUvZnJvbnRlbmQvZ3JvdXBvbl9tb2R1bGVzL3ZlcmlmeVVzZXJDb29raWVzLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDQSxPQUFPLENBQUMsaUJBQVIsR0FBNEIsU0FBQTtTQUMxQixVQUFBLENBQVcsQ0FBQyxTQUFBO0FBQ1YsUUFBQTtJQUFBLElBQUEsQ0FBYyxDQUFBLEdBQUEsR0FBTSxPQUFPLENBQUMsU0FBUyxDQUFDLGFBQXhCLENBQWQ7QUFBQSxhQUFBOztJQUVBLCtDQUErQixDQUFFLE9BQXZCLENBQStCLGlCQUEvQixVQUFWO0FBQUEsYUFBQTs7SUFDQSxFQUFBLEdBQUssUUFBUSxDQUFDLGFBQVQsQ0FBdUIsUUFBdkI7SUFDTCxFQUFFLENBQUMsRUFBSCxHQUFRO0lBQ1IsRUFBRSxDQUFDLEtBQUgsR0FBVztJQUNYLFFBQVEsQ0FBQyxJQUFJLENBQUMsV0FBZCxDQUEwQixFQUExQixDQUE2QixDQUFDLEdBQTlCLEdBQW9DO0FBQ3BDO2dGQUNFLGNBQWMsQ0FBRSxPQUFoQixDQUF3QixpQkFBeEIsRUFBMkMsSUFBM0MsV0FERjtLQUFBO0VBUlUsQ0FBRCxDQUFYLEVBVUMsQ0FWRDtBQUQwQiJ9
